import styled from "styled-components"

const RowStyled = styled.div`
    position: relative;
    width: 100%;
    height: 2em;

    display: grid;
    grid-template-columns: subgrid;
    grid-column: 1 / -1;
    align-items: center;

    p:first-child {
        text-align: left;
    }

    p:last-child {
        text-align: right;
    }
`

const VolumeLevelStyled = styled.div`
    position: absolute;
    right: 0;
    top: 0;
    height: 100%;
    opacity: 0.1;

`

export { RowStyled, VolumeLevelStyled }
